import React, { Component } from 'react'
import { Row, Column } from '../../global/grid/grid'
import Image from '../../global/media/Image'
import Video from '../../global/media/Video'

import { FWAWrapper, ColorBlock } from './styled-components'

class FullWidthAsset extends Component {
  constructor (props) {
    super(props)
  }
  render () {
    const { data, imageDictionary, videoDictionary } = this.props
    if (data.assetType === 'image') {
      return (
        <FWAWrapper>
          <Row margins>
            <Column className='assetHolder' cw={10} offset={1} style={{ position: 'relative' }}>
              <Image aspectHeight={9} aspectWidth={16} sizes={imageDictionary[data.asset].sizes} />
              <ColorBlock color={data.color}>
                <div className='stripes' />
              </ColorBlock>
            </Column>
          </Row>
        </FWAWrapper>
      )
    } else if (data.assetType === 'video') {
      return (
        <FWAWrapper>
          <Row margins>
            <Column className='assetHolder' cw={10} offset={1} style={{ position: 'relative' }}>
              <Video srcMp4={videoDictionary[data.assetMp4]} srcWebM={videoDictionary[data.assetWebM]} />
              <ColorBlock color={data.color}>
                <div className='stripes' />
              </ColorBlock>
            </Column>
          </Row>
        </FWAWrapper>
      )
    }
  }
}

export default FullWidthAsset



// WEBPACK FOOTER //
// ./src/components/modules/FullWidthAsset/FullWidthAsset.js